import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EntityValue, EntityValueUpdate } from "@/model";
import entityValueRepository from "@/repository/entityValueRepository";
import { entityQueryKeys } from "@/query/entity";
import { entityValueQueryKeys } from "./keys";


export const useUpdateEntityValue = (agentId: number, entityId: string, entityValueId?: string) => {
    const queryClient = useQueryClient();

    return useMutation<EntityValue, AxiosError, EntityValueUpdate>({
        mutationKey: ["entity-value", "update", agentId, entityId, entityValueId],
        mutationFn: async (form: EntityValueUpdate) => {
            try {
                if (!entityValueId) {
                    return;
                }
                const { data } = await entityValueRepository.update(agentId, entityId, entityValueId, form);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.recent(agentId),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: entityValueQueryKeys.pageAll(agentId, entityId)
            });
        }
    });
};
